import { isLocal } from '@web3/base-utils';

export const SensorScript = () => {
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line no-template-curly-in-string
          __html: `
          function findSpm (dom, deep = 5) {
            if (dom) {
              const { spmName, spmEven, spmData, button_name, page_name } =
                dom.dataset || {};
              if (spmName || spmEven || button_name) {
                return {
                  button_name: button_name || '',
                  page_name: page_name || '',
                  spmName: spmName || '',
                  spmEven: spmEven || '',

                  spmData,
                };
              } else if (dom.parentNode) {
                return findSpm(dom.parentNode, deep--);
              } else {
                return {};
              }
            } else {
              return {};
            }
          }
          // 自定义配置
          // initOpts用于初始化神策实例配置
          initOpts = {
            show_log: false,
            heatmap: {
              // data-spm-name 【默认的web click事件】一般对应的按钮的名字，语言应该以英文为主
              // data-spm-even 【自定义的埋点事件，这个和spm-name互斥】埋点事件名字，在很多场合下，如果不想调用useTracking，那么直接使用data-spm-even=埋点事件名字，如果有附加数据，配合data-spm-data使用
              // data-spm-data 附加的事件数据
              track_attr: ['data-button_name', 'data-spm-name', 'data-spm-even'],
              // 默认只有点击 a input button textarea 四种元素时，才会触发   $WebClick 元素点击事件
              clickmap: 'default',
              collect_tags: {
                button: true,
                a: true,
                input: true,
                textarea: true,
                li: true,
                img: true,
                div: true,
                // ... 其他标签
              },
              // 是否开启触达注意力图，自动采集 $WebStay 事件, default 表示开启
              // 神策默认超过 4 秒即为一个有效的页面停留
              scroll_notice_map: 'default',
              //此参数针对预置 $WebClick 事件（包括 quick('trackHeatMap') quick('trackAllHeatMap') 触发的）生效。
              custom_property: function (target) {
                const { spmName, spmEven, button_name, page_name, spmData } =
                  findSpm(target);
                // console.log('button click', { target });
                let data = {};
                try {
                  if (spmData) {
                    data = JSON.parse(spmData || '{}');
                  }
                } catch (e) {
                  data = {};
                }
                // 这里会触发神策的自定义事件上传
                if (spmEven) {
                  if (button_name) {
                    data.button_name = button_name;
                  }
                  window.top?.sensors.track(spmEven, data);
                }
                // 这里会触发神策预定义$webclick事件
                if (spmName || button_name) {
                  return {
                    spmName,
                    button_name,
                    page_name,
                    ...data,
                  };
                }
              },
            },
          }`,
        }}
      />
      {!isLocal && (
        <script
          src={'/common-static/infra-static/data-core/data-core.latest.min.js'}
        ></script>
      )}
    </>
  );
};
